// frontend/src/navigation/recentVisits.js

/**
 * recentVisits — die zuletzt besuchten Flaechen, im Browser gemerkt (W-20).
 *
 * @description
 *   Atlassians dritter Mechanismus gegen 70+ Routen ist nicht Sichtbarkeit,
 *   sondern Reihenfolge: „Recent / Starred als Ersatz dafuer, sich den Baum zu
 *   merken". Die Palette zeigt bei leerer Eingabe zuerst, wo man eben war.
 *
 * 🔴 WARUM `localStorage` HIER RICHTIG IST — und wo es falsch waere.
 *   Richtig: es ist eine Bequemlichkeit FUER DIESEN NUTZER auf DIESEM Geraet.
 *   Geht der Speicher verloren, ist nichts kaputt; die Liste ist dann leer und
 *   die Palette zeigt den Katalog. Das ist ein akzeptabler Ausgangszustand.
 *   Falsch waere es fuer alles, was geteilt oder verlaesslich sein muss — dafuer
 *   gibt es den Server.
 *
 * 🔴 JEDER ZUGRIFF IST EINGEPACKT. Ein privates Fenster, geloeschte Seitendaten
 *   oder eine Richtlinie lassen `localStorage` WERFEN statt leer zurueckkommen.
 *   Eine Palette, die beim Oeffnen abstuerzt, weil der Speicher gesperrt ist,
 *   waere ein Navigationsausfall wegen einer Bequemlichkeit.
 */

const SCHLUESSEL = 'forge.recentSurfaces'
const MAX = 6

/** Zuletzt besuchte Pfade, neueste zuerst. Leer, wenn nichts lesbar ist. */
export function holeZuletzt() {
  try {
    const roh = window.localStorage.getItem(SCHLUESSEL)
    if (!roh) return []
    const arr = JSON.parse(roh)
    return Array.isArray(arr) ? arr.filter(p => typeof p === 'string').slice(0, MAX) : []
  } catch {
    return []
  }
}

/** Merkt einen Besuch. Ein Pfad steht nur einmal in der Liste, vorn. */
export function merkeBesuch(pfad) {
  if (!pfad || typeof pfad !== 'string') return
  try {
    const liste = [pfad, ...holeZuletzt().filter(p => p !== pfad)].slice(0, MAX)
    window.localStorage.setItem(SCHLUESSEL, JSON.stringify(liste))
  } catch {
    // Gesperrter Speicher ist kein Fehler, den jemand sehen muesste: die
    // Reihenfolge ist Bequemlichkeit, kein Zustand.
  }
}

/**
 * Sortiert Eintraege so, dass zuletzt Besuchte vorn stehen.
 *
 * 🔴 Nur bei LEERER Eingabe angewandt. Sobald jemand tippt, entscheidet die
 *   Suche — sonst schluege ein alter Besuch einen besseren Treffer.
 */
export function mitZuletzt(eintraege, zuletzt) {
  if (!zuletzt.length) return eintraege
  const rang = new Map(zuletzt.map((p, i) => [p, i]))
  return [...eintraege].sort((a, b) => {
    const ra = rang.has(a.path) ? rang.get(a.path) : Number.MAX_SAFE_INTEGER
    const rb = rang.has(b.path) ? rang.get(b.path) : Number.MAX_SAFE_INTEGER
    return ra - rb
  })
}
